import CryptoJS from 'crypto-js';
import { defaultUser } from '@/store/module/user';
const sign = 'e07157b7b815bf2b3add52523f95326b';
interface collectData {
  i?: string; // 事件id
  d?: string; // 收集数据 json 包含uid
  t?: string; // 时间戳【13位，毫秒】
}
// 接口验签
export const toSign = (obj: string, key?: any) => {
  // 按照升序排序obj属性
  const sortObj: collectData = {};
  sortObj.i = obj;
  sortObj.t = String(Date.parse(String(new Date())));
  sortObj.d = JSON.stringify({
    uid: defaultUser.userinfo.id,
    ...key
  });
  const newkey = Object.keys(sortObj).sort();
  const newObj: any = {};
  newkey.forEach((item, i) => {
    // 遍历newkey数组
    newObj[newkey[i]] = sortObj[newkey[i]];
    // 向新创建的对象中按照排好的顺序依次增加键值对
  });
  const keyArr = [];
  for (const y in newObj) {
    if (true) {
      const x = newObj[y];
      if (typeof newObj[y] === 'object') {
        keyArr.push(y + '=' + JSON.stringify(x.map(String)));
      } else {
        keyArr.push(y + '=' + x);
      }
    }
  }
  const keySign = keyArr.join('&');
  const result = CryptoJS.HmacSHA1(keySign, sign).toString(CryptoJS.enc.Hex);
  newObj.sign = result;
  return newObj;
};

export const toSigns = (obj: any) => {
  // 按照升序排序obj属性
  const sortObj = obj;
  const newkey = Object.keys(sortObj).sort();
  const newObj: any = {};
  newkey.forEach((item, i) => {
    // 遍历newkey数组
    newObj[newkey[i]] = sortObj[newkey[i]];
    // 向新创建的对象中按照排好的顺序依次增加键值对
  });
  const keyArr: any = [];
  for (const y in newObj) {
    if (true) {
      const x = newObj[y];
      if (typeof newObj[y] === 'object') {
        keyArr.push(y + '=' + JSON.stringify(x.map(String)));
      } else {
        keyArr.push(y + '=' + x);
      }
    }
  }
  const keySign = keyArr.join('&');
  const result = CryptoJS.HmacSHA1(keySign, sign).toString(CryptoJS.enc.Hex);
  newObj.sign = result;
  return newObj;
};
export const wxH5Encrypted = (obj: any) => {
  const message = JSON.stringify(obj);
  // 密钥，AES需要16、24或32位长度的密钥
  const key = CryptoJS.enc.Utf8.parse('1234567890123456'); // 16位密钥
  // 初始化向量（IV），AES CBC模式需要16位长度的IV
  const iv = CryptoJS.enc.Utf8.parse('1234567890123456'); // 16位IV

  // 加密
  const encrypted = CryptoJS.AES.encrypt(message, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
};
